import {
  DailyExpenseMonthRow,
  DailyExpenseTotals,
} from "../../types/daily-expense.type";
import { roundHalfUp } from "../../utils/money";

/** The S2 summary boxes double as the list's filter: ทั้งหมด, ยังไม่กรอก, ถูกตีกลับ. */
export type MonthFilter = "ALL" | "NOT_STARTED" | "REJECTED";

export const filterMonthRows = (
  rows: DailyExpenseMonthRow[],
  filter: MonthFilter,
): DailyExpenseMonthRow[] => {
  if (filter === "NOT_STARTED") return rows.filter((row) => row.status === null);
  if (filter === "REJECTED") return rows.filter((row) => row.status === "REJECTED");
  return rows;
};

/** Clicking the box already in force goes back to ทั้งหมด. */
export const toggleMonthFilter = (current: MonthFilter, clicked: MonthFilter): MonthFilter =>
  current === clicked ? "ALL" : clicked;

const MONTH_LIST_TITLE: Record<Exclude<MonthFilter, "ALL">, string> = {
  NOT_STARTED: "วันที่ยังไม่กรอก",
  REJECTED: "วันที่ถูกตีกลับ",
};

export const monthListTitleOf = (filter: MonthFilter, monthLabel: string) =>
  filter === "ALL" ? `รายการเดือน${monthLabel}` : MONTH_LIST_TITLE[filter];

/** The totals row of the rows on screen, each column rounded half-up to the satang. */
export const sumMonthRows = (rows: DailyExpenseMonthRow[]): DailyExpenseTotals => {
  const sumOf = (pick: (row: DailyExpenseMonthRow) => number) =>
    roundHalfUp(rows.reduce((sum, row) => sum + pick(row), 0));
  const salesTotal = sumOf((row) => row.sales_total);
  const adminTotal = sumOf((row) => row.admin_total);
  return {
    sales_total: salesTotal,
    admin_total: adminTotal,
    total: roundHalfUp(salesTotal + adminTotal),
  };
};

export interface NeighbourDates {
  previous: string | null;
  next: string | null;
}

/** ‹ วันก่อน / วันถัดไป › step through the days the month list holds, not the calendar. */
export const neighbourDatesOf = (
  rows: DailyExpenseMonthRow[],
  businessDate: string,
): NeighbourDates => {
  const dates = rows.map((row) => row.business_date).sort();
  const earlier = dates.filter((date) => date < businessDate);
  return {
    previous: earlier.length > 0 ? earlier[earlier.length - 1] : null,
    next: dates.find((date) => date > businessDate) ?? null,
  };
};
